import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ViewEncapsulation, Renderer2, PLATFORM_ID, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { GlobalLoaderService } from 'src/app/modules/shared/_services/global-loader.service';
import { environment } from 'src/environments/environment';
import { SigninWithOtpComponent } from 'src/app/modules/auth/_components/signin-with-otp/signin-with-otp.component';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { ViewDetailsTrackerService } from './../../../shared/_services/view-details-tracker-service.service';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: 'app-listing-card',
  templateUrl: './listing-card.component.html',
  styleUrls: ['./listing-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListingCardComponent implements OnInit, OnDestroy {

  @Input() tenders: any;
  @Input() tenderPayload: any;
  @Input() totalPage: any; // Assuming it's a number
  @Input() activeTendersCount: any;
  @Input() searchTerm: any;
  @Input() activePage: any;

  @Output() pageChanged = new EventEmitter<number>();
  @ViewChild(SigninWithOtpComponent) modal!: SigninWithOtpComponent;

  tooltip: string = 'Copy to Clipboard';
  isTooltipActive: boolean = false;
  baseUrl: any = environment.TENDER.BASE_URL;
  currentPageUrl: any;
  isLoggedIn: any;
  private userSubscription!: Subscription;
  currentPage = 1;
  pages: number[] = [];
  maxPagesToShow = 4;
  isBrowser: boolean = false;

  constructor(private globalLoaderService: GlobalLoaderService, private sharedService: SharedService,
    public router: Router, private authService: AuthService, private renderer: Renderer2,
    private viewDetailsTrackerService: ViewDetailsTrackerService, @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = this.sharedService.isBrowser;
    // this.isLoggedIn = this.authService.isLoggedIn();
    this.userSubscription = this.authService.user$.subscribe(user => {
      this.isLoggedIn = !!user;
    });
    // if (this.sharedService.isBrowser) {
    //   this.currentPageUrl = window.location.href;
    // }
  }

  ngOnInit(): void {
    this.currentPage = this.activePage || 1;
    // this.currentPageUrl = window.location.origin + window.location.pathname;
    // Only set currentPageUrl if running in the browser
    if (isPlatformBrowser(this.platformId)) {
      this.currentPageUrl = window.location.origin + window.location.pathname;
    } else {
      // Construct URL for SSR using baseUrl and router info
      this.currentPageUrl = `${this.baseUrl}${this.router.url.split('?')[0]}`;
    }
    this.updateRelLinks();
  }

  private updateRelLinks() {
    if (isPlatformBrowser(this.platformId)) {
      const head = document.head;

      // Remove existing prev/next links
      document.querySelectorAll("link[rel='prev'], link[rel='next']").forEach(link => link.remove());

      // Only add `prev` if currentPage is greater than 1
      if (this.currentPage > 1) {
        const prevLink = this.renderer.createElement('link');
        this.renderer.setAttribute(prevLink, 'rel', 'prev');
        this.renderer.setAttribute(prevLink, 'href', `${this.currentPageUrl}?page=${this.currentPage - 1}`);
        this.renderer.appendChild(head, prevLink);
      }

      // Add `next` if there are more pages ahead
      if (this.currentPage < this.totalPage) {
        const nextLink = this.renderer.createElement('link');
        this.renderer.setAttribute(nextLink, 'rel', 'next');
        this.renderer.setAttribute(nextLink, 'href', `${this.currentPageUrl}?page=${this.currentPage + 1}`);
        this.renderer.appendChild(head, nextLink);
      }
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChange(this.currentPage);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPage) {
      this.currentPage++;
      this.pageChange(this.currentPage);
    }
  }

  pageChange(page: number) {
    this.router.navigate([], {
      queryParams: { page },
      queryParamsHandling: 'merge',
    });
    this.pageChanged.emit(page);
    this.updateRelLinks(); // Update links dynamically
  }

  isModalvis: boolean = false;
  openModalWithComponent(type: any) {
    this.isModalvis = true;
    setTimeout(() => {
      if (this.modal) {
        this.modal.isVisible = true; // Open the modal
        if (type === 'restrict') {
          this.modal.userRestrict = true;
          this.modal.isDownloadDoc = false;
        } else {
          this.modal.isDownloadDoc = true; // Open the modal
        }
      }
    }, 0);
  }

  navigate(link: string, type: any): void {
    if (this.isLoggedIn) {
      this.router.navigateByUrl('/' + link);
    } else {
      this.viewDetailsTrackerService.incrementClickCount();
      if (this.viewDetailsTrackerService.shouldPromptSignup()) {
        this.promptSignup();
      } else {
        this.router.navigateByUrl('/' + link);
      }
    }

    // Push dataLayer events based on the type
    if (type === 'viewdetail') {
      window.dataLayer.push({ 'event': 'View Details-TLP' });
    } else if (type === 'title') {
      window.dataLayer.push({ 'event': 'Tender Title Clicked-TLP' });
    } else if (type === 'readmore') {
      window.dataLayer.push({ 'event': 'Read More Clicked-TLP' });
    }
  }

  promptSignup(): void {
    // Trigger the login/signup flow here.
    this.openModalWithComponent('restrict');
    // alert('Please sign up to continue viewing more details.');
  }

  shareTenderDetails(hrefUrl: string, medium: string) {
    if (this.sharedService.isBrowser) {
      window.open(hrefUrl, '_blank');
    }
  }

  shareTenderDetailsWhatsapp(url: any): void {
    let whatsappUrl: string;
    if (this.isMobile()) {
      whatsappUrl = 'whatsapp://send?text=' + encodeURIComponent(this.baseUrl + url);
    } else {
      whatsappUrl = 'https://web.whatsapp.com/send?text=' + encodeURIComponent(this.baseUrl + url);
    }
    if (this.sharedService.isBrowser) {
      window.open(whatsappUrl, '_blank');
    }
  }

  private isMobile(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  copyTextToClipboard(url: any): void {
    this.tooltip = 'Copied!';
    if (this.sharedService.isBrowser) {
      navigator.clipboard.writeText(this.baseUrl + url)
        .then(() => {
        })
        .catch(err => {
          // Error handling
          console.error('Failed to copy URL to clipboard:', err);
        });
    }
    this.isTooltipActive = true;
  }

  tenderDetailsPageUrl(tender: any) {
    if (this.sharedService.isBrowser) {
      let currentOriginUrl = this.router['location']._platformLocation.location.origin;
      return `${currentOriginUrl}${this.sharedService.tenderDetailsPageUrl(
        tender
      )}`;
    } else {
      return '';
    }
  }

  trackByTenderId(index: number, tender: any): number {
    return tender.id; // Replace `id` with the actual unique property of your tender
  }

  downloadDoc(doc: any) {
    if (doc) {
      this.globalLoaderService.setLoaderState(true);
      this.sharedService.downloadFile(doc?.url)
        .subscribe((res: any) => {
          this.globalLoaderService.setLoaderState(false);
          const file = new Blob([res], { type: res.type });
          saveAs(file, doc?.name);
          window.dataLayer.push({ 'event': 'Download Document Clicked-TOP' });
        }, (err: any) => {
          this.globalLoaderService.setLoaderState(false);
        });
    }
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

}




